import React, { Fragment, useState } from "react";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import AxiosConfig from "axiosConfig";
import "containers/Projects/Details/ProjectDetails.css";
import "../../../../node_modules/video-react/dist/video-react.css";
import "containers/ProjectCommon.css";
import ProjectBanner from "components/Project/ProjectBanner";
import TextTheme from "../../../components/General/Text/TextTheme";
import Project_logo from "../../../site_media/images/project_default.jpg";
import SpreadTheWordSummary from "components/Project/ActiveProject/ProjectComplete/SpreadTheWordSummary";
import LearnNewSkillSummary from "components/Project/ActiveProject/ProjectComplete/LearnNewSkillSummary";
import DevelopNewHabitSummary from "components/Project/ActiveProject/ProjectComplete/DevelopNewHabitSummary";
import VolunteerTimeSummary from "components/Project/ActiveProject/ProjectComplete/VolunteerTimeSummary";
import GiveADonationSummary from "components/Project/ActiveProject/ProjectComplete/GiveADonationSummary";
import FundraiseSummary from "components/Project/ActiveProject/ProjectComplete/FundraiseSummary";
import RaiseYourVoiceSummary from "components/Project/ActiveProject/ProjectComplete/RaiseYourVoiceSummary";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton.js";
import Button from "react-bootstrap/Button";
import { FaCheck } from "react-icons/fa";
import CustomDatepicker from "../../../components/General/Form/CustomDatepicker";
import ActiveProjectInfo from "../../../components/Project/Home/ActiveProjectHomeInfo/ActiveProjectInfo";

class ProjectSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectMission: "",
      projectBanner: "",
      projectName: "",
      projectBadge: "",
      imageList: [],
      showChallengeDetails: false,
      projectList: [],
    };
  }

  componentDidMount() {
    const projectSlug = this.props.match.params.slug;
    Promise.all([
      AxiosConfig.get(`/impactprojects/project/${projectSlug}/`),
      AxiosConfig.get(
        `/impactprojects/project/completed_challenges/${projectSlug}`
      ),
      AxiosConfig.get(`/impactprojects/project/challenges/${projectSlug}`),
      AxiosConfig.get(
        `/impactprojects/active_challenge_details/${projectSlug}`
      ),
    ])
      .then(([res1, res2, res3, res4]) => {
        if (res1) {
          this.setState({
            projectMission: res1.data.mission,
            projectName: res1.data.name,
            projectBanner: res1.data.banner,
            projectBadge: res1.data.badge,
          });
        }
        if (res2) {
          this.setState({
            imageList: res2.data.completed_challenge_list,
          });
        }
        if (res3) {
          var response_data = res3["data"];
          var i;
          var challengeList = [];
          let challengeInfo = new Map();
          for (i = 0; i < response_data.length; i++) {
            challengeList[i] = response_data[i];
            challengeInfo.set(
              response_data[i]["slug"],
              response_data[i]["adventure"]
            );
          }
          this.setState({
            challengeList: challengeList,
            challengeInfo: challengeInfo,
          });
        }
        if (res4) {
          this.setState({
            projectList: res4.data,
          });
        }
      })
      .catch();
  }
  renderChallengeDetails(
    event,
    challenge_slug,
    challenge_image,
    challengeName,
    adventureSlug,
    projectUserId,
    prizeImage,
    dateStarted
  ) {
    this.setState({
      challengeImage: challenge_image,
      showChallengeDetails: true,
      challengeSlug: challenge_slug,
      challengeName: challengeName,
      adventureSlug: adventureSlug,
      projectUserId: projectUserId,
      prizeImage: prizeImage,
      projectStarted: dateStarted,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  hideChallengeDetails() {
    this.setState({ showChallengeDetails: false });
  }
  renderChallengeInfo() {
    const { adventureSlug } = this.state;
    const projectSlug =this.props.match.params.slug;
    if (adventureSlug === "SPREAD_THE_WORD") {
      return (
        <SpreadTheWordSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "LEARN_NEW_SKILL") {
      return (
        <LearnNewSkillSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "DEVELOP_NEW_HABIT") {
      return (
        <DevelopNewHabitSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "VOLUNTEER") {
      return (
        <VolunteerTimeSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "GIVE_A_DONATION") {
      return (
        <GiveADonationSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "RAISE_FUNDS") {
      return (
        <FundraiseSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else if (adventureSlug === "RAISE_YOUR_VOICE") {
      return (
        <RaiseYourVoiceSummary
          projectSlug={projectSlug}
          challengeSlug={this.state.challengeSlug}
          video={this.props.video}
          projectUserId={this.state.projectUserId}
          challengeName={this.state.challengeName}
        />
      );
    } else {
      return null;
    }
  }
  handleDateChange = (event) => {
    const goalDate_Str = this.formatDate(event.target.value);
    this.setState({ goalDate: new Date(goalDate_Str) });
  };
  onSubmit() {
    const projectSlug = this.props.match.params.slug;
    let nextUrl = "";
    if (this.state.adventureSlug == "SPREAD_THE_WORD") {
      nextUrl = "/projects/" + projectSlug + "/spread-the-word";
    } else if (this.state.adventureSlug == "LEARN_NEW_SKILL") {
      nextUrl = "/projects/" + projectSlug + "/learn-new-skill";
    } else if (this.state.adventureSlug == "DEVELOP_NEW_HABIT") {
      nextUrl = "/projects/" + projectSlug + "/develop-new-habit";
    } else if (this.state.adventureSlug == "VOLUNTEER") {
      nextUrl = "/projects/" + projectSlug + "/volunteer-time";
    } else if (this.state.adventureSlug == "GIVE_A_DONATION") {
      nextUrl = "/projects/" + projectSlug + "/give-a-donation";
    } else if (this.state.adventureSlug == "RAISE_FUNDS") {
      nextUrl = "/projects/" + projectSlug + "/fundraise";
    } else if (this.state.adventureSlug == "RAISE_YOUR_VOICE") {
      nextUrl = "/projects/" + projectSlug + "/raise-your-voice";
    }

    if (
      this.state.challengeName == "" ||
      this.state.goalDate == "" ||
      this.state.challengeName == undefined ||
      this.state.goalDate == undefined
    ) {
      this.setState({
        errorMessage: "Please select a challenge and a target date",
      });
    } else {
      this.setState({ errorMessage: "" });
      let form_data = new FormData();
      form_data.append("project", projectSlug);
      form_data.append("challenge", this.state.challengeName);
      form_data.append("goal_date", this.formatDate(this.state.goalDate));
      form_data.append("projectUserId", undefined);
      AxiosConfig.post("/impactprojects/start_new/", form_data)
        .then((res) => {
          let projectUserId = res.data.project_user_id;
          this.props.history.push({
            pathname: `/projects/${projectSlug}/start-project-step-one`,
            state: {
              challengeSlug: this.state.challengeName,
              goalDate: this.formatDate(this.state.goalDate),
              adventureId: this.state.adventureId,
              adventureSlug: this.state.adventureSlug,
              projectUserId: projectUserId,
            },
          });
        })
        .catch();
    }
  }
  startProject_new = (challengeSlug) => {
    const project = this.props.match.params.slug;
    let adventure = this.state.challengeInfo.get(challengeSlug);
    this.setState({
      challengeName: challengeSlug,
      adventureId: adventure.id,
      adventureSlug: adventure.slug,
      showModal: false,
    });
    var elems = document.getElementsByClassName("ChallengesDescription");
    [].forEach.call(elems, function (el) {
      el.classList.remove("active");
    });
    document.getElementById(challengeSlug).classList.add("active");
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  render() {
    var date = new Date(this.state.projectStarted),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    let finalDate = [mnth, day, date.getFullYear()].join("/");
    return (
      <div className="header_main project-complete">
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo
              vertical={true}
              project={this.props.match.params.slug}
            />
          </div>
          <div
            className={
              this.state.showChallengeDetails
                ? "page_details_main project-summary "
                : "page_details_main project-summary show"
            }
          >
            <div className="project-banner">
              <ProjectBanner image={this.state.projectBanner} />
            </div>
            <div className="page_info_hr_content_main">
              <ProjectOldInfo project={this.props.match.params.slug} />
            </div>
            <div className="page_details_content_main mt-15">
              <div className="mb-15 projectNameFormat">
                <span className="textHeader">EXPLORE &amp; LEARN</span>
              </div>
              <div className="d-flex project-details">
                <div>
                  <img
                    src={this.state.projectBadge}
                    className="profile_pic_vertical"
                  />
                </div>
                <div>
                  <a href={`/projects/${this.props.match.params.slug}`}>
                    <TextTheme
                      message={this.state.projectName}
                      className="text_semi_bold text_medium text_dark_blue"
                    />
                  </a>
                  <div
                    className="insideContent"
                    dangerouslySetInnerHTML={{
                      __html: this.state.projectMission,
                    }}
                  ></div>
                  <a href={`/projects/${this.props.match.params.slug}`}>
                    <TextTheme
                      message="Read on"
                      className="text_semi_bold text_small text_dark_blue mt-15 "
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className="page_details_content_main mt-15">
              <div className="mb-15 projectNameFormat">
                <span className="textHeader">CURRENT CHALLENGES</span>
              </div>
              <div className="project-details">
                {this.state.projectList.length > 0 ? (
                  <ActiveProjectInfo
                    projectList={this.state.projectList}
                    listType={"Active"}
                  />
                ) : (
                  <TextTheme
                    message="No Active Challenges"
                    className="mt-15 mb-15 text_small text_med_grey text-center"
                  />
                )}
              </div>
            </div>
            {this.state.projectList.length <= 0 ? (
              <div className="page_details_content_main mt-15">
                <div className="mb-15 projectNameFormat">
                  <span className="textHeader">CHOOSE YOUR NEXT CHALLENGE</span>
                </div>
                <div className="">
                  <div className="project-details">
                    <div className="insideContent">
                      <p className="insideContent">
                        Wait, our work here is not done yet! Choose your next
                        amazing challenge to help make a bigger impact on the
                        project mission.
                      </p>
                    </div>
                    <div trigger="Challenges">
                      {this.state.challengeList &&
                        this.state.challengeList.map((element, index) => (
                          <div
                            onClick={() =>
                              this.startProject_new(element["slug"])
                            }
                            className={
                              this.state.challengeName === element.slug
                                ? "ChallengesDescription active"
                                : "ChallengesDescription"
                            }
                            id={element.slug}
                          >
                            <span className="check">
                              <FaCheck size={18} style={{ fill: "#ff431b" }} />
                            </span>
                            <section
                              className="left-section"
                              style={{
                                backgroundImage: `url(${element.image})`,
                              }}
                            ></section>
                            <section className="right-section">
                              <h3 className="textHeader">{element["name"]}</h3>
                              <div
                                className="insideContent"
                                dangerouslySetInnerHTML={{
                                  __html: element["desc"].substring(0, 550),
                                }}
                              ></div>
                            </section>
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="project-details mt-15">
                    <div className="mt-15 insideContent">
                      2. Set a target date to complete your goal:
                    </div>
                    <div className="Datepicker">
                      <CustomDatepicker
                        value={this.state.goalDate}
                        handleChange={this.handleDateChange.bind(this)}
                        placeholder="MM/DD/YYYY"
                        minDate={new Date()}
                      />
                    </div>
                  </div>
                  <div className="project-details">
                    <TextTheme
                      message={this.state.errorMessage}
                      className="text_small text_red text-center"
                    />
                  </div>
                  <div className="project-details">
                    <Button
                      onClick={this.onSubmit.bind(this)}
                      className="startButton"
                      size="lg"
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="page_details_content_main mt-15">
              <div className="mb-15 projectNameFormat">
                <span className="textHeader">COMPLETED CHALLENGES</span>
              </div>
              {this.state.imageList.length > 0 ? (
                <ul className="challenges-complete">
                  {this.state.imageList &&
                    this.state.imageList.map((elm) => (
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={(event) =>
                            this.renderChallengeDetails(
                              event,
                              elm.challenge_slug,
                              elm.challenge_image,
                              elm.challenge_name,
                              elm.adventure_slug,
                              elm.project_user_id,
                              elm.project_user_prize,
                              elm.date_started
                            )
                          }
                          style={{
                            backgroundImage: `url(${elm.challenge_image})`,
                          }}
                        >
                          <span>{elm.challenge_name}</span>
                        </a>
                      </li>
                    ))}
                </ul>
              ) : (
                <TextTheme
                  message="No Challenges Completed Yet"
                  className="mt-15 mb-15 text_small text_med_grey text-center"
                />
              )}
            </div>
          </div>
          <div
            className={
              this.state.showChallengeDetails
                ? "page_details_main show"
                : "page_details_main"
            }
          >
            <div className="page_details_content_main">
              <div
                className="mb-15 challenge-img"
                style={{
                  backgroundImage: `url(${this.state.challengeImage}`,
                }}
              ></div>
              <div className="challenge-name">
                <label className="textHeader">{this.state.challengeName}</label>
              </div>
              <div className="d-inline-block challenge-details">
                <label className="d-block text_dark_blue project-name mt-15">
                  <b>Project Date</b>
                </label>
                <label className="d-block project-name">{finalDate}</label>
                <label className="d-block text_dark_blue project-name mt-15">
                  <b>Accomplishments</b>
                </label>
                <Fragment>
                  {this.state.showChallengeDetails
                    ? this.renderChallengeInfo()
                    : null}
                </Fragment>
                <label className="d-block text_dark_blue project-name mt-15">
                  <b>Awards</b>
                </label>
                <div
                  className="prize-img"
                  style={{
                    backgroundImage: `url(${
                      this.state.prizeImage || Project_logo
                    }`,
                  }}
                ></div>
                {this.state.invitedBy ? (
                  <Fragment>
                    <label className="d-block text_dark_blue project-name mt-15">
                      <b>From</b>
                    </label>
                    <label className="d-block project-name">
                      {this.state.invitedBy}
                    </label>
                  </Fragment>
                ) : null}
                <div className="navigate-done">
                  <RoundedButton
                    title="Done"
                    buttonClassName="background_dark_orange"
                    textThemeClassName="text_medium text_white"
                    float="none"
                    handleOnClick={(event) => this.hideChallengeDetails()}
                    borderRadius="6px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ProjectSummary;
